module.exports = __webpack_public_path__ + "img/1439326983.365523ea.jpg";